import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const CardFragmentDoc = gql`
    fragment Card on ComponentSharedCard {
  title
  description
  cover {
    url
  }
  url
}
    `;
export const SeoFragmentDoc = gql`
    fragment Seo on ComponentSharedSeo {
  id
  metaTitle
  metaDescription
  keywords
  uri
}
    `;
export const AboutFragmentDoc = gql`
    fragment About on About {
  friends {
    ...Card
  }
  authors {
    ...Card
  }
  seo {
    ...Seo
  }
  documentId
  text
}
    ${CardFragmentDoc}
${SeoFragmentDoc}`;
export const ArticleCardFragmentDoc = gql`
    fragment ArticleCard on Article {
  documentId
  title
  description
  slug
  teaser
  pinned
  updatedAt
  publishedAt
  seo {
    ...Seo
  }
  category {
    name
    documentId
    slug
  }
  cover {
    url
    alternativeText
    formats
  }
  author {
    documentId
    name
    avatar {
      url
    }
  }
}
    ${SeoFragmentDoc}`;
export const FamilyMemberFragmentDoc = gql`
    fragment FamilyMember on ComponentDomainFamilyMember {
  id
  relationship
  rider {
    documentId
    slug
    name
  }
}
    `;
export const LinkFragmentDoc = gql`
    fragment Link on ComponentSharedLink {
  name
  url
  type
  id
}
    `;
export const RiderCardFragmentDoc = gql`
    fragment RiderCard on Rider {
  documentId
  photo {
    previewUrl
    url
    formats
    alternativeText
  }
  birthPlace
  externalUuid
  externalId
  legend
  name
  slug
  weight
  riderNumber
  teamColor
  startDate
  endDate
  height
  description
  active
  stats
  statistics
  career
  birthDate
  deathDate
  country
}
    `;
export const RiderRaceResultFragmentDoc = gql`
    fragment RiderRaceResult on Result {
  year
  documentId
  track {
    slug
    documentId
    name
    country
  }
  points
  position
  type
  didNotFinish
  racingClass
  didNotFinish
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  documentId
  name
  slug
}
    `;
export const TrackCardFragmentDoc = gql`
    fragment TrackCard on Track {
  name
  slug
  description
  country
  location
  country
  direction
  leftCorners
  rightCorners
  totalLength
  totalWidth
  documentId
  engineer
  externalUuid
  longestStraightLength
  timezone
  layout {
    url
    alternativeText
  }
}
    `;
export const CreateCommentDocument = gql`
    mutation createComment($data: CommentInput!) {
  createComment(data: $data, status: PUBLISHED) {
    user {
      username
    }
    text
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateContactDocument = gql`
    mutation createContact($data: ContactInput!) {
  createContact(data: $data) {
    createdAt
    documentId
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const CreateResultDocument = gql`
    mutation createResult($data: ResultInput!) {
  createResult(data: $data, status: PUBLISHED) {
    publishedAt
  }
}
    `;
export type CreateResultMutationFn = Apollo.MutationFunction<CreateResultMutation, CreateResultMutationVariables>;

/**
 * __useCreateResultMutation__
 *
 * To run a mutation, you first call `useCreateResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResultMutation, { data, loading, error }] = useCreateResultMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateResultMutation(baseOptions?: Apollo.MutationHookOptions<CreateResultMutation, CreateResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResultMutation, CreateResultMutationVariables>(CreateResultDocument, options);
      }
export type CreateResultMutationHookResult = ReturnType<typeof useCreateResultMutation>;
export type CreateResultMutationResult = Apollo.MutationResult<CreateResultMutation>;
export type CreateResultMutationOptions = Apollo.BaseMutationOptions<CreateResultMutation, CreateResultMutationVariables>;
export const CreateRiderDocument = gql`
    mutation createRider($data: RiderInput!) {
  createRider(data: $data) {
    documentId
    name
  }
}
    `;
export type CreateRiderMutationFn = Apollo.MutationFunction<CreateRiderMutation, CreateRiderMutationVariables>;

/**
 * __useCreateRiderMutation__
 *
 * To run a mutation, you first call `useCreateRiderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiderMutation, { data, loading, error }] = useCreateRiderMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRiderMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiderMutation, CreateRiderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiderMutation, CreateRiderMutationVariables>(CreateRiderDocument, options);
      }
export type CreateRiderMutationHookResult = ReturnType<typeof useCreateRiderMutation>;
export type CreateRiderMutationResult = Apollo.MutationResult<CreateRiderMutation>;
export type CreateRiderMutationOptions = Apollo.BaseMutationOptions<CreateRiderMutation, CreateRiderMutationVariables>;
export const LoginDocument = gql`
    mutation login($input: UsersPermissionsLoginInput!) {
  login(input: $input) {
    jwt
    user {
      id
      email
      username
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = gql`
    mutation register($input: UsersPermissionsRegisterInput!) {
  register(input: $input) {
    jwt
    user {
      id
      email
      username
    }
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const UpdateRiderDocument = gql`
    mutation updateRider($documentId: ID!, $data: RiderInput!) {
  updateRider(documentId: $documentId, data: $data) {
    updatedAt
    documentId
  }
}
    `;
export type UpdateRiderMutationFn = Apollo.MutationFunction<UpdateRiderMutation, UpdateRiderMutationVariables>;

/**
 * __useUpdateRiderMutation__
 *
 * To run a mutation, you first call `useUpdateRiderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiderMutation, { data, loading, error }] = useUpdateRiderMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRiderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiderMutation, UpdateRiderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiderMutation, UpdateRiderMutationVariables>(UpdateRiderDocument, options);
      }
export type UpdateRiderMutationHookResult = ReturnType<typeof useUpdateRiderMutation>;
export type UpdateRiderMutationResult = Apollo.MutationResult<UpdateRiderMutation>;
export type UpdateRiderMutationOptions = Apollo.BaseMutationOptions<UpdateRiderMutation, UpdateRiderMutationVariables>;
export const AboutDocument = gql`
    query about {
  about {
    ...About
  }
}
    ${AboutFragmentDoc}`;

/**
 * __useAboutQuery__
 *
 * To run a query within a React component, call `useAboutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAboutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAboutQuery({
 *   variables: {
 *   },
 * });
 */
export function useAboutQuery(baseOptions?: Apollo.QueryHookOptions<AboutQuery, AboutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AboutQuery, AboutQueryVariables>(AboutDocument, options);
      }
export function useAboutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AboutQuery, AboutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AboutQuery, AboutQueryVariables>(AboutDocument, options);
        }
export function useAboutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AboutQuery, AboutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AboutQuery, AboutQueryVariables>(AboutDocument, options);
        }
export type AboutQueryHookResult = ReturnType<typeof useAboutQuery>;
export type AboutLazyQueryHookResult = ReturnType<typeof useAboutLazyQuery>;
export type AboutSuspenseQueryHookResult = ReturnType<typeof useAboutSuspenseQuery>;
export type AboutQueryResult = Apollo.QueryResult<AboutQuery, AboutQueryVariables>;
export const ArticleDocument = gql`
    query article($documentId: ID!, $slug: String) {
  article(documentId: $documentId) {
    ...ArticleCard
    tags {
      ...Tag
      articles(
        sort: ["publishedAt:desc"]
        pagination: {limit: 3}
        filters: {publishedAt: {notNull: true}, slug: {nei: $slug}}
      ) {
        ...ArticleCard
        tags {
          ...Tag
        }
      }
    }
  }
}
    ${ArticleCardFragmentDoc}
${TagFragmentDoc}`;

/**
 * __useArticleQuery__
 *
 * To run a query within a React component, call `useArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useArticleQuery(baseOptions: Apollo.QueryHookOptions<ArticleQuery, ArticleQueryVariables> & ({ variables: ArticleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
      }
export function useArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
        }
export function useArticleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleQuery, ArticleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleQuery, ArticleQueryVariables>(ArticleDocument, options);
        }
export type ArticleQueryHookResult = ReturnType<typeof useArticleQuery>;
export type ArticleLazyQueryHookResult = ReturnType<typeof useArticleLazyQuery>;
export type ArticleSuspenseQueryHookResult = ReturnType<typeof useArticleSuspenseQuery>;
export type ArticleQueryResult = Apollo.QueryResult<ArticleQuery, ArticleQueryVariables>;
export const ArticlesDocument = gql`
    query articles {
  articles(
    status: PUBLISHED
    pagination: {limit: 100}
    sort: ["publishedAt:desc"]
  ) {
    ...ArticleCard
    tags {
      ...Tag
    }
  }
}
    ${ArticleCardFragmentDoc}
${TagFragmentDoc}`;

/**
 * __useArticlesQuery__
 *
 * To run a query within a React component, call `useArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useArticlesQuery(baseOptions?: Apollo.QueryHookOptions<ArticlesQuery, ArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, options);
      }
export function useArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticlesQuery, ArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, options);
        }
export function useArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticlesQuery, ArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, options);
        }
export type ArticlesQueryHookResult = ReturnType<typeof useArticlesQuery>;
export type ArticlesLazyQueryHookResult = ReturnType<typeof useArticlesLazyQuery>;
export type ArticlesSuspenseQueryHookResult = ReturnType<typeof useArticlesSuspenseQuery>;
export type ArticlesQueryResult = Apollo.QueryResult<ArticlesQuery, ArticlesQueryVariables>;
export const BikesDocument = gql`
    query bikes {
  bikes(pagination: {limit: 100}) {
    documentId
    externalUuid
    name
    slug
    country
    logo {
      url
    }
  }
}
    `;

/**
 * __useBikesQuery__
 *
 * To run a query within a React component, call `useBikesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBikesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBikesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBikesQuery(baseOptions?: Apollo.QueryHookOptions<BikesQuery, BikesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BikesQuery, BikesQueryVariables>(BikesDocument, options);
      }
export function useBikesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BikesQuery, BikesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BikesQuery, BikesQueryVariables>(BikesDocument, options);
        }
export function useBikesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BikesQuery, BikesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BikesQuery, BikesQueryVariables>(BikesDocument, options);
        }
export type BikesQueryHookResult = ReturnType<typeof useBikesQuery>;
export type BikesLazyQueryHookResult = ReturnType<typeof useBikesLazyQuery>;
export type BikesSuspenseQueryHookResult = ReturnType<typeof useBikesSuspenseQuery>;
export type BikesQueryResult = Apollo.QueryResult<BikesQuery, BikesQueryVariables>;
export const CommentsDocument = gql`
    query comments($slug: String!) {
  comments(filters: {article: {slug: {eq: $slug}}}) {
    text
    publishedAt
    documentId
    user {
      username
    }
  }
}
    `;

/**
 * __useCommentsQuery__
 *
 * To run a query within a React component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCommentsQuery(baseOptions: Apollo.QueryHookOptions<CommentsQuery, CommentsQueryVariables> & ({ variables: CommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
      }
export function useCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export function useCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<typeof useCommentsLazyQuery>;
export type CommentsSuspenseQueryHookResult = ReturnType<typeof useCommentsSuspenseQuery>;
export type CommentsQueryResult = Apollo.QueryResult<CommentsQuery, CommentsQueryVariables>;
export const GlobalDocument = gql`
    query global {
  global {
    documentId
    seo {
      ...Seo
    }
    socials {
      ...Link
    }
  }
}
    ${SeoFragmentDoc}
${LinkFragmentDoc}`;

/**
 * __useGlobalQuery__
 *
 * To run a query within a React component, call `useGlobalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalQuery(baseOptions?: Apollo.QueryHookOptions<GlobalQuery, GlobalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalQuery, GlobalQueryVariables>(GlobalDocument, options);
      }
export function useGlobalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalQuery, GlobalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalQuery, GlobalQueryVariables>(GlobalDocument, options);
        }
export function useGlobalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalQuery, GlobalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalQuery, GlobalQueryVariables>(GlobalDocument, options);
        }
export type GlobalQueryHookResult = ReturnType<typeof useGlobalQuery>;
export type GlobalLazyQueryHookResult = ReturnType<typeof useGlobalLazyQuery>;
export type GlobalSuspenseQueryHookResult = ReturnType<typeof useGlobalSuspenseQuery>;
export type GlobalQueryResult = Apollo.QueryResult<GlobalQuery, GlobalQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    username
    email
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const RacesDocument = gql`
    query races($racingClass: String, $racingType: String) {
  races(pagination: {limit: 25}) {
    documentId
    schedule(filters: {racingClass: {eq: $racingClass}, type: {eq: $racingType}}) {
      startDate
      type
      racingClass
    }
    track {
      ...TrackCard
    }
  }
}
    ${TrackCardFragmentDoc}`;

/**
 * __useRacesQuery__
 *
 * To run a query within a React component, call `useRacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRacesQuery({
 *   variables: {
 *      racingClass: // value for 'racingClass'
 *      racingType: // value for 'racingType'
 *   },
 * });
 */
export function useRacesQuery(baseOptions?: Apollo.QueryHookOptions<RacesQuery, RacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RacesQuery, RacesQueryVariables>(RacesDocument, options);
      }
export function useRacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RacesQuery, RacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RacesQuery, RacesQueryVariables>(RacesDocument, options);
        }
export function useRacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RacesQuery, RacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RacesQuery, RacesQueryVariables>(RacesDocument, options);
        }
export type RacesQueryHookResult = ReturnType<typeof useRacesQuery>;
export type RacesLazyQueryHookResult = ReturnType<typeof useRacesLazyQuery>;
export type RacesSuspenseQueryHookResult = ReturnType<typeof useRacesSuspenseQuery>;
export type RacesQueryResult = Apollo.QueryResult<RacesQuery, RacesQueryVariables>;
export const ResultReviewDocument = gql`
    query resultReview($url: String!) {
  resultReviews(status: PUBLISHED, filters: {url: {eq: $url}}) {
    title
    text
    documentId
  }
}
    `;

/**
 * __useResultReviewQuery__
 *
 * To run a query within a React component, call `useResultReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useResultReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultReviewQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useResultReviewQuery(baseOptions: Apollo.QueryHookOptions<ResultReviewQuery, ResultReviewQueryVariables> & ({ variables: ResultReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResultReviewQuery, ResultReviewQueryVariables>(ResultReviewDocument, options);
      }
export function useResultReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResultReviewQuery, ResultReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResultReviewQuery, ResultReviewQueryVariables>(ResultReviewDocument, options);
        }
export function useResultReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResultReviewQuery, ResultReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResultReviewQuery, ResultReviewQueryVariables>(ResultReviewDocument, options);
        }
export type ResultReviewQueryHookResult = ReturnType<typeof useResultReviewQuery>;
export type ResultReviewLazyQueryHookResult = ReturnType<typeof useResultReviewLazyQuery>;
export type ResultReviewSuspenseQueryHookResult = ReturnType<typeof useResultReviewSuspenseQuery>;
export type ResultReviewQueryResult = Apollo.QueryResult<ResultReviewQuery, ResultReviewQueryVariables>;
export const ResultsDocument = gql`
    query results($filters: ResultFiltersInput) {
  results(filters: $filters, pagination: {limit: 1000}) {
    documentId
    avgSpeed
    didNotFinish
    avgSpeed
    points
    year
    rider {
      documentId
    }
  }
}
    `;

/**
 * __useResultsQuery__
 *
 * To run a query within a React component, call `useResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useResultsQuery(baseOptions?: Apollo.QueryHookOptions<ResultsQuery, ResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResultsQuery, ResultsQueryVariables>(ResultsDocument, options);
      }
export function useResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResultsQuery, ResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResultsQuery, ResultsQueryVariables>(ResultsDocument, options);
        }
export function useResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResultsQuery, ResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResultsQuery, ResultsQueryVariables>(ResultsDocument, options);
        }
export type ResultsQueryHookResult = ReturnType<typeof useResultsQuery>;
export type ResultsLazyQueryHookResult = ReturnType<typeof useResultsLazyQuery>;
export type ResultsSuspenseQueryHookResult = ReturnType<typeof useResultsSuspenseQuery>;
export type ResultsQueryResult = Apollo.QueryResult<ResultsQuery, ResultsQueryVariables>;
export const RiderDocument = gql`
    query rider($slug: ID!) {
  rider(documentId: $slug) {
    ...RiderCard
    seo {
      ...Seo
    }
    races
    familyMembers {
      ... on ComponentDomainFamilyMember {
        id
        rider {
          documentId
          name
          slug
        }
        relationship
      }
    }
    results(
      pagination: {limit: 1000}
      filters: {position: {eq: 1}}
      sort: ["year:asc"]
    ) {
      ...RiderRaceResult
    }
  }
}
    ${RiderCardFragmentDoc}
${SeoFragmentDoc}
${RiderRaceResultFragmentDoc}`;

/**
 * __useRiderQuery__
 *
 * To run a query within a React component, call `useRiderQuery` and pass it any options that fit your needs.
 * When your component renders, `useRiderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRiderQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useRiderQuery(baseOptions: Apollo.QueryHookOptions<RiderQuery, RiderQueryVariables> & ({ variables: RiderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RiderQuery, RiderQueryVariables>(RiderDocument, options);
      }
export function useRiderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RiderQuery, RiderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RiderQuery, RiderQueryVariables>(RiderDocument, options);
        }
export function useRiderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RiderQuery, RiderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RiderQuery, RiderQueryVariables>(RiderDocument, options);
        }
export type RiderQueryHookResult = ReturnType<typeof useRiderQuery>;
export type RiderLazyQueryHookResult = ReturnType<typeof useRiderLazyQuery>;
export type RiderSuspenseQueryHookResult = ReturnType<typeof useRiderSuspenseQuery>;
export type RiderQueryResult = Apollo.QueryResult<RiderQuery, RiderQueryVariables>;
export const RidersDocument = gql`
    query riders($filters: RiderFiltersInput, $page: Int = 1, $pageSize: Int = 24) {
  riders(
    filters: $filters
    pagination: {pageSize: $pageSize, page: $page}
    sort: ["riderNumber:asc", "id:asc"]
  ) {
    ...RiderCard
  }
}
    ${RiderCardFragmentDoc}`;

/**
 * __useRidersQuery__
 *
 * To run a query within a React component, call `useRidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRidersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useRidersQuery(baseOptions?: Apollo.QueryHookOptions<RidersQuery, RidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RidersQuery, RidersQueryVariables>(RidersDocument, options);
      }
export function useRidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RidersQuery, RidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RidersQuery, RidersQueryVariables>(RidersDocument, options);
        }
export function useRidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RidersQuery, RidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RidersQuery, RidersQueryVariables>(RidersDocument, options);
        }
export type RidersQueryHookResult = ReturnType<typeof useRidersQuery>;
export type RidersLazyQueryHookResult = ReturnType<typeof useRidersLazyQuery>;
export type RidersSuspenseQueryHookResult = ReturnType<typeof useRidersSuspenseQuery>;
export type RidersQueryResult = Apollo.QueryResult<RidersQuery, RidersQueryVariables>;
export const SearchDocument = gql`
    query search($query: String!) {
  search(query: $query) {
    articles {
      nodes {
        ...ArticleCard
      }
    }
    riders {
      nodes {
        ...RiderCard
      }
    }
    tracks {
      nodes {
        ...TrackCard
      }
    }
  }
}
    ${ArticleCardFragmentDoc}
${RiderCardFragmentDoc}
${TrackCardFragmentDoc}`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables> & ({ variables: SearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export function useSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<typeof useSearchSuspenseQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const SeasonsDocument = gql`
    query seasons {
  seasons(sort: "year:desc", pagination: {limit: 100}) {
    documentId
    year
    externalUuid
  }
}
    `;

/**
 * __useSeasonsQuery__
 *
 * To run a query within a React component, call `useSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSeasonsQuery(baseOptions?: Apollo.QueryHookOptions<SeasonsQuery, SeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeasonsQuery, SeasonsQueryVariables>(SeasonsDocument, options);
      }
export function useSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeasonsQuery, SeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeasonsQuery, SeasonsQueryVariables>(SeasonsDocument, options);
        }
export function useSeasonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeasonsQuery, SeasonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeasonsQuery, SeasonsQueryVariables>(SeasonsDocument, options);
        }
export type SeasonsQueryHookResult = ReturnType<typeof useSeasonsQuery>;
export type SeasonsLazyQueryHookResult = ReturnType<typeof useSeasonsLazyQuery>;
export type SeasonsSuspenseQueryHookResult = ReturnType<typeof useSeasonsSuspenseQuery>;
export type SeasonsQueryResult = Apollo.QueryResult<SeasonsQuery, SeasonsQueryVariables>;
export const TagDocument = gql`
    query tag($slug: ID!) {
  tag(documentId: $slug, status: PUBLISHED) {
    ...Tag
    articles(
      pagination: {limit: 3}
      sort: ["publishedAt:desc"]
      filters: {publishedAt: {notNull: true}}
    ) {
      ...ArticleCard
      tags {
        ...Tag
      }
    }
  }
}
    ${TagFragmentDoc}
${ArticleCardFragmentDoc}`;

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTagQuery(baseOptions: Apollo.QueryHookOptions<TagQuery, TagQueryVariables> & ({ variables: TagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagQuery, TagQueryVariables>(TagDocument, options);
      }
export function useTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagQuery, TagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagQuery, TagQueryVariables>(TagDocument, options);
        }
export function useTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagQuery, TagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagQuery, TagQueryVariables>(TagDocument, options);
        }
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagSuspenseQueryHookResult = ReturnType<typeof useTagSuspenseQuery>;
export type TagQueryResult = Apollo.QueryResult<TagQuery, TagQueryVariables>;
export const TeamsDocument = gql`
    query teams {
  teams(pagination: {limit: 100}) {
    name
    color
    textColor
    documentId
    slug
  }
}
    `;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export function useTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsSuspenseQueryHookResult = ReturnType<typeof useTeamsSuspenseQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export const TrackDocument = gql`
    query track($slug: ID!) {
  track(documentId: $slug) {
    ...TrackCard
    records
    video
    seo {
      ...Seo
    }
    results(
      pagination: {limit: 1000}
      sort: ["year:asc"]
      filters: {position: {eq: 1}, didNotFinish: {eq: false}, type: {eq: "RAC"}}
    ) {
      documentId
      type
      rider {
        ...RiderCard
      }
      bike {
        documentId
        name
        slug
      }
      position
    }
  }
}
    ${TrackCardFragmentDoc}
${SeoFragmentDoc}
${RiderCardFragmentDoc}`;

/**
 * __useTrackQuery__
 *
 * To run a query within a React component, call `useTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTrackQuery(baseOptions: Apollo.QueryHookOptions<TrackQuery, TrackQueryVariables> & ({ variables: TrackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackQuery, TrackQueryVariables>(TrackDocument, options);
      }
export function useTrackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackQuery, TrackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackQuery, TrackQueryVariables>(TrackDocument, options);
        }
export function useTrackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackQuery, TrackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrackQuery, TrackQueryVariables>(TrackDocument, options);
        }
export type TrackQueryHookResult = ReturnType<typeof useTrackQuery>;
export type TrackLazyQueryHookResult = ReturnType<typeof useTrackLazyQuery>;
export type TrackSuspenseQueryHookResult = ReturnType<typeof useTrackSuspenseQuery>;
export type TrackQueryResult = Apollo.QueryResult<TrackQuery, TrackQueryVariables>;
export const TracksDocument = gql`
    query tracks($filters: TrackFiltersInput) {
  tracks(pagination: {limit: 100}, filters: $filters) {
    ...TrackCard
    results(filters: {position: {eq: 1}}, pagination: {limit: 75}) {
      documentId
      year
    }
    races {
      documentId
      schedule {
        type
        startDate
      }
    }
  }
}
    ${TrackCardFragmentDoc}`;

/**
 * __useTracksQuery__
 *
 * To run a query within a React component, call `useTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTracksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTracksQuery(baseOptions?: Apollo.QueryHookOptions<TracksQuery, TracksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TracksQuery, TracksQueryVariables>(TracksDocument, options);
      }
export function useTracksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TracksQuery, TracksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TracksQuery, TracksQueryVariables>(TracksDocument, options);
        }
export function useTracksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TracksQuery, TracksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TracksQuery, TracksQueryVariables>(TracksDocument, options);
        }
export type TracksQueryHookResult = ReturnType<typeof useTracksQuery>;
export type TracksLazyQueryHookResult = ReturnType<typeof useTracksLazyQuery>;
export type TracksSuspenseQueryHookResult = ReturnType<typeof useTracksSuspenseQuery>;
export type TracksQueryResult = Apollo.QueryResult<TracksQuery, TracksQueryVariables>;
export const TranslationsDocument = gql`
    query translations($locale: I18NLocaleCode!) {
  translations(locale: $locale, pagination: {limit: 1000}) {
    documentId
    key
    value
  }
}
    `;

/**
 * __useTranslationsQuery__
 *
 * To run a query within a React component, call `useTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useTranslationsQuery(baseOptions: Apollo.QueryHookOptions<TranslationsQuery, TranslationsQueryVariables> & ({ variables: TranslationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranslationsQuery, TranslationsQueryVariables>(TranslationsDocument, options);
      }
export function useTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranslationsQuery, TranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranslationsQuery, TranslationsQueryVariables>(TranslationsDocument, options);
        }
export function useTranslationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TranslationsQuery, TranslationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TranslationsQuery, TranslationsQueryVariables>(TranslationsDocument, options);
        }
export type TranslationsQueryHookResult = ReturnType<typeof useTranslationsQuery>;
export type TranslationsLazyQueryHookResult = ReturnType<typeof useTranslationsLazyQuery>;
export type TranslationsSuspenseQueryHookResult = ReturnType<typeof useTranslationsSuspenseQuery>;
export type TranslationsQueryResult = Apollo.QueryResult<TranslationsQuery, TranslationsQueryVariables>;
export const UpcomingRaceDocument = gql`
    query upcomingRace($date: DateTime!) {
  races(filters: {schedule: {startDate: {gt: $date}}}, pagination: {limit: 1}) {
    documentId
    track {
      slug
      documentId
    }
  }
}
    `;

/**
 * __useUpcomingRaceQuery__
 *
 * To run a query within a React component, call `useUpcomingRaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingRaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingRaceQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUpcomingRaceQuery(baseOptions: Apollo.QueryHookOptions<UpcomingRaceQuery, UpcomingRaceQueryVariables> & ({ variables: UpcomingRaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingRaceQuery, UpcomingRaceQueryVariables>(UpcomingRaceDocument, options);
      }
export function useUpcomingRaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingRaceQuery, UpcomingRaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingRaceQuery, UpcomingRaceQueryVariables>(UpcomingRaceDocument, options);
        }
export function useUpcomingRaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpcomingRaceQuery, UpcomingRaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpcomingRaceQuery, UpcomingRaceQueryVariables>(UpcomingRaceDocument, options);
        }
export type UpcomingRaceQueryHookResult = ReturnType<typeof useUpcomingRaceQuery>;
export type UpcomingRaceLazyQueryHookResult = ReturnType<typeof useUpcomingRaceLazyQuery>;
export type UpcomingRaceSuspenseQueryHookResult = ReturnType<typeof useUpcomingRaceSuspenseQuery>;
export type UpcomingRaceQueryResult = Apollo.QueryResult<UpcomingRaceQuery, UpcomingRaceQueryVariables>;
export const UpdateDocument = gql`
    query update {
  update {
    documentId
    title
    version
    entries(pagination: {limit: 100}) {
      text
      date
      color
      id
    }
  }
}
    `;

/**
 * __useUpdateQuery__
 *
 * To run a query within a React component, call `useUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateQuery(baseOptions?: Apollo.QueryHookOptions<UpdateQuery, UpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateQuery, UpdateQueryVariables>(UpdateDocument, options);
      }
export function useUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateQuery, UpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateQuery, UpdateQueryVariables>(UpdateDocument, options);
        }
export function useUpdateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateQuery, UpdateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateQuery, UpdateQueryVariables>(UpdateDocument, options);
        }
export type UpdateQueryHookResult = ReturnType<typeof useUpdateQuery>;
export type UpdateLazyQueryHookResult = ReturnType<typeof useUpdateLazyQuery>;
export type UpdateSuspenseQueryHookResult = ReturnType<typeof useUpdateSuspenseQuery>;
export type UpdateQueryResult = Apollo.QueryResult<UpdateQuery, UpdateQueryVariables>;